module.exports = __webpack_public_path__ + "media/src/application/media/help_4-e5ebec5ff27904b86ab67332ab636c3c.jpg";